import React from "react";
import StaticText from "components/form/StaticText";
import InputText from "components/form/InputText";
import Select from "components/form/Select";
import CheckboxList from "components/form/CheckboxList";
import TextArea from "components/form/TextArea";
import Date from "components/form/Date";
import MaskedInput from "components/form/InputTextWithMask";
import PropTypes from "prop-types";
import { MailtoLink } from "ctia-ui";

const FormElementSelector = ({ type, ...rest }) => {
  switch (type) {
    case "text":
      return <InputText {...rest} />;
    case "select":
      return <Select {...rest} />;
    case "checkboxList":
      return <CheckboxList {...rest} />;
    case "textarea":
      return <TextArea {...rest} />;
    case "date":
      return <Date {...rest} />;
    case "maskedInput":
      return <MaskedInput {...rest} />;
    case "emailLink":
      const style = "bold green";
      return <MailtoLink textStyle={style} {...rest} />;
    default:
      return <StaticText {...rest} />;
  }
};

FormElementSelector.propTypes = {
  type: PropTypes.string
};

export default FormElementSelector;



// WEBPACK FOOTER //
// ./src/components/FormElementSelector.js